import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheck, Download, Users } from 'lucide-react';
export function ClosingCTA() {
  return <section className="bg-ink py-24 px-4 border-t border-white/5 relative overflow-hidden" data-id="element-49">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-forest rounded-full blur-[100px] opacity-40 pointer-events-none" data-id="element-50"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-51">
        <h2 className="font-display text-5xl md:text-6xl text-white mb-8 uppercase leading-tight" data-id="element-52">
          Your Next Practice Doesn't Have to Be{' '}
          <span className="text-red-500" data-id="element-53">Stressful.</span>
        </h2>

        <p className="text-xl text-gray-300 leading-relaxed mb-12 max-w-3xl mx-auto" data-id="element-54">
          Every week you keep searching for ideas is another week you're not
          coaching at your best. Your players deserve better sessions. You
          deserve to enjoy coaching again. Soccer Ready™ gives you everything
          you need to show up confident, organized, and ready — starting with
          your next practice.
        </p>

        <div className="flex flex-col items-center" data-id="element-55">
          <CTAButton text="Get Soccer Ready™ Now — Instant Access →" className="py-5 px-10 text-xl md:text-2xl" data-id="element-56" />

          <div className="mt-8 flex flex-wrap justify-center items-center gap-y-3 gap-x-6 text-sm text-gray-400 font-medium" data-id="element-57">
            <div className="flex items-center gap-1.5" data-id="element-58">
              <ShieldCheck className="w-5 h-5 text-brightGreen" data-id="element-59" />
              <span data-id="element-60">7-Day Guarantee</span>
            </div>
            <span className="hidden md:inline text-gray-600" data-id="element-61">|</span>
            <div className="flex items-center gap-1.5" data-id="element-62">
              <Download className="w-5 h-5 text-brightGreen" data-id="element-63" />
              <span data-id="element-64">Instant Download</span>
            </div>
            <span className="hidden md:inline text-gray-600" data-id="element-65">|</span>
            <div className="flex items-center gap-1.5" data-id="element-66">
              <Users className="w-5 h-5 text-brightGreen" data-id="element-67" />
              <span data-id="element-68">Join 1,000+ Coaches Already Using Soccer Ready™</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}